import { useEffect, useRef, useState, useContext } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { ThemeContext } from "../../../theme/ThemeContext";

const SolutionStep = ({ id, stepName, stepText, isValid, removeHandler, isSubmitted, valueHandler, disableDelete }) => {

  const editorRef = useRef(null);
  const [stepValue, setStepValue] = useState(stepText || "<p></p>");
  const stepTextRef = useRef(stepText);
  const [stepValueIsValid, setStepValueIsValid] = useState(isValid);

  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  useEffect(() => {
  if (stepText !== stepTextRef.current) {
    setStepValue(stepText || "<p></p>");
    stepTextRef.current = stepText;
  }
  }, [stepText]);

  useEffect(() => {
    if (!editorRef.current) return;

    const editor = editorRef.current;

    const handleCopy = (e) => {
      const html = editor.selection.getContent({ format: "html" });
      if (!html.includes(`class="copyable"`)) e.preventDefault();
    };

    editor.on("copy", handleCopy);
    return () => editor.off("copy", handleCopy); 
  }, []);

  return (
    <div className="row mb-4">
      <div className="col-6"><small><b>{stepName}</b></small></div>
      <div className="col-6">
        {!disableDelete && (
          <button type="button" className="float-end text-danger btn btn-sm" title="Remove"
            onClick={() => removeHandler(id)}>
            <i className="pi pi-trash" />
          </button>
        )}
      </div>
        <div className="col-12 mt-2">
        <Editor
          key={theme} 
          tinymceScriptSrc="/tinymce/tinymce.min.js"
          onInit={(evt, editor) => (editorRef.current = editor)}
          value={stepValue}
          licenseKey="gpl"
         onEditorChange={(content) => {
        setStepValue(content);

         const isEmpty = !content || 
                  content.trim() === "" || 
                  content === "<p></p>" || 
                  content === "<p><br></p>";

         setStepValueIsValid(!isEmpty);
          valueHandler(id, content);
          }}

          init={{
            menubar: false,
            plugins: [
              "autoresize", 
              "advlist", "autolink", "lists", "link", "image",
              "charmap", "anchor", "searchreplace", "visualblocks", "code",
              "fullscreen", "insertdatetime", "media", "table", "preview",
              "help", "wordcount"
            ],
            toolbar:"bold italic underline | bullist numlist | alignleft aligncenter alignright | link image | code | command",

            setup: (editor) => {
              editor.ui.registry.addButton("command", {
                icon: "copy",
                tooltip: "Wrap selected text as copyable command (double-click to edit)",
              onAction: () => {
             const html = editor.selection.getContent({ format: "html" }).trim();
           if (!html) {
           editor.notificationManager.open({
           text: "Select text first",
           type: "warning",
           timeout: 1500
           });
          return;
           }
          editor.insertContent(
          `<span class="copyable" contenteditable="false">${html}</span>`
          );
             }
              });

         /* Double click Convert back to normal editable text */
           editor.on("dblclick", (e) => {
            const span = e.target.closest?.(".copyable");
            if (!span) return;
            e.preventDefault();
            const formattedContent = span.innerHTML;
            const container = editor.getDoc().createElement("div");
            container.innerHTML = formattedContent;
            while (container.firstChild) {
            editor.dom.insertAfter(container.firstChild, span);
            }
            editor.dom.remove(span);
           if (container.lastChild) {
           const range = editor.getDoc().createRange();
           range.setStartAfter(container.lastChild);
           range.setEndAfter(container.lastChild);
          editor.selection.setRng(range);
            }
          });

              editor.on("keydown", (e) => {
                const node = editor.selection.getNode();
                const inside = node?.classList?.contains("copyable") || node?.closest?.(".copyable");
                if (!inside) return;

                const key = e.key;
                const formatting = (e.ctrlKey || e.metaKey) || ["b","i","u"].includes(key.toLowerCase());
                if (!formatting && key.length === 1) e.preventDefault();
              });
            },
            skin: isDark ? "oxide-dark" : "oxide",
            content_css: isDark ? "dark" : "default",
            content_style: `
              body { background:${isDark?"#191919":"#fff"}; color:${isDark?"#fff":"#000"}; font-size:14px; }
              body *:not(.copyable):not(.copyable *) { user-select:none!important; }
              .copyable { user-select:text!important; background:${isDark?"rgba(27,95,116,.87)":"#eef"};
                padding:2px 3px;border-radius:3px;display:inline-block; }
            `,
            autoresize_bottom_margin: 20,
            min_height: 200,
            max_height: 600,
          }}
        />
{isSubmitted && !stepValueIsValid && (
  <p className="text-danger mt-1">Please provide {stepName}</p>
)}
      </div>
    </div>
  );
};

export default SolutionStep;
